import { render } from "./ShareAchievement.vue?vue&type=template&id=048ee75f&scoped=true"
import script from "./ShareAchievement.vue?vue&type=script&lang=js"
export * from "./ShareAchievement.vue?vue&type=script&lang=js"

import "./ShareAchievement.vue?vue&type=style&index=0&id=048ee75f&lang=postcss&scoped=true"

import exportComponent from "/codebuild/output/src1692007530/src/wfyt-widget/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-048ee75f"]])

export default __exports__